// src/components/ServicesSection.js
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import AOS from "aos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlug,
  faTools,
  faHammer,
  faBuilding,
  faHouseUser,
} from "@fortawesome/free-solid-svg-icons";
import "./ServicesStyle.css";

const Services = ({ id }) => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out",
      once: true,
    });
  }, []);

  return (
    <section id={id} className="services-section">
      <div className="services-content">
        <h2 data-aos="fade-up" data-aos-offset="200">
          {t("services.title")}
        </h2>
        <div className="services-grid">
          <div
            className="service-item"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={faPlug} size="lg" />
            </div>
            <div className="service-details">
              <h3>{t("services.property_handover")}</h3>
              <p>{t("services.property_handover_desc")}</p>
            </div>
          </div>

          <div
            className="service-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={faTools} size="lg" />
            </div>
            <div className="service-details">
              <h3>{t("services.engineering")}</h3>
              <p>{t("services.engineering_desc")}</p>
            </div>
          </div>

          <div
            className="service-item"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={faHammer} size="lg" />
            </div>
            <div className="service-details">
              <h3>{t("services.contracting")}</h3>
              <p>{t("services.contracting_desc")}</p>
            </div>
          </div>

          <div
            className="service-item"
            data-aos="fade-left"
            data-aos-offset="200"
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={faBuilding} size="lg" />
            </div>
            <div className="service-details">
              <h3>{t("services.project_development")}</h3>
              <p>{t("services.project_development_desc")}</p>
            </div>
          </div>

          <div
            className="service-item"
            data-aos="fade-right"
            data-aos-offset="200"
          >
            <div className="service-icon">
              <FontAwesomeIcon icon={faHouseUser} size="lg" />
            </div>
            <div className="service-details">
              <h3>{t("services.real_estate")}</h3>
              <p>{t("services.real_estate_desc")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
